import { Selector } from "@green24/npm-preact-utils/store";

export const applicationSelector = new Selector("application", {editOnly: true});
export const configurationSelector = new Selector("configuration", {editOnly: true});
export const settingsSelector = new Selector("settings");
export const locationSelector = new Selector("location");
